import * as React from 'react';
import * as styles from './styles.css';
import cn from 'classnames';
import { Outside, Popover } from '@cian/ui-kit';
import { useDropdownControls } from '../useDropdownControls';
import { ErrorPopover } from '../../ErrorPopover';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Базовый дропдаун под нужды фильтров
 * Рендерит выпадающий список с помощью render-пропса
 * Рендерит мастер-компонент с помощью render-пропаса
 *  */
export var Dropdown = function Dropdown(props) {
  var master = props.master,
      render = props.render,
      testId = props.testId,
      _props$classes = props.classes,
      classes = _props$classes === void 0 ? {} : _props$classes,
      _props$errorMessage = props.errorMessage,
      errorMessage = _props$errorMessage === void 0 ? '' : _props$errorMessage,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottom-start' : _props$placement;

  var _useDropdownControls = useDropdownControls(),
      handleClose = _useDropdownControls.handleClose,
      handleToggle = _useDropdownControls.handleToggle,
      isOpen = _useDropdownControls.isOpen;

  var dropdownCss = React.useMemo(function () {
    return cn(styles['dropdown_base'], classes.dropdown || styles['dropdown']);
  }, [classes.dropdown]);
  return /*#__PURE__*/_jsx(Popover, {
    open: isOpen,
    content: /*#__PURE__*/_jsx(Outside, {
      onOutside: handleClose,
      children: /*#__PURE__*/_jsx("div", {
        className: dropdownCss,
        "data-testid": testId,
        children: render({
          handleClose: handleClose,
          handleToggle: handleToggle,
          isOpen: isOpen
        })
      })
    }),
    placement: placement,
    flip: false,
    preventOverflow: true,
    children: /*#__PURE__*/_jsx("div", {
      className: cn(styles['container'], classes.root),
      children: /*#__PURE__*/_jsx(ErrorPopover, {
        tooltipContent: errorMessage,
        placement: "bottom-start",
        children: master({
          handleClose: handleClose,
          handleToggle: handleToggle,
          isOpen: isOpen
        })
      })
    })
  });
};
Dropdown.displayName = 'Dropdown';